import { ReactNode, useState } from 'react';

const GFC = (
  <a href="https://glenfallscabin.com" target="_blank" rel="noopener noreferrer" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors font-medium">
    Glen Falls Luxury Cabin
  </a>
);

interface FAQ {
  q: string;
  a: ReactNode;
}

const FAQS: FAQ[] = [
  {
    q: 'What are the best places to stay in Highlands, NC?',
    a: <>The best places to stay in Highlands, NC include {GFC} (top-rated cabin with a 5.0-star Airbnb Guest Favorite rating), Old Edwards Inn and Spa (premier luxury hotel in downtown Highlands), Half-Mile Farm (boutique inn with farm-to-table dining), Highlander Mountain House (stylish boutique hotel), and several well-regarded cabin rentals including Laurelwood, Stag Ridge, Falls Drive Cottage, and Whispering Walk. The right choice depends on your preferences for privacy, service level, and proximity to town.</>,
  },
  {
    q: 'Are there luxury cabins in Highlands, NC?',
    a: <>Yes. Highlands, NC has a strong luxury cabin rental market. {GFC} is the top-rated option, with a 5.0-star Airbnb Guest Favorite rating, stone fireplaces, a covered deck, and a secluded wooded setting minutes from downtown. Stag Ridge is another well-regarded luxury cabin option with a wraparound deck and premium finishes.</>,
  },
  {
    q: 'Is it better to stay in a cabin or hotel in Highlands, NC?',
    a: "It depends on what you're looking for. Cabins offer more privacy, a full kitchen, outdoor space, and a more immersive mountain experience — ideal for longer stays, families, or anyone who values independence. Hotels like Old Edwards Inn offer concierge service, on-site dining, and spa amenities — better for shorter visits or guests who prefer full-service hospitality. Many repeat visitors to Highlands prefer cabins for the overall experience.",
  },
  {
    q: 'Are there pet friendly places to stay in Highlands, NC?',
    a: <>Yes. Several places to stay in Highlands, NC welcome pets. {GFC} is one of the most popular pet-friendly options, with a wooded setting and nearby trails. Stag Ridge and Lark Lodge also accept pets. Most hotels in Highlands do not accept pets, so cabin rentals are generally the better option for travelers with dogs.</>,
  },
  {
    q: 'How far are cabins from downtown Highlands, NC?',
    a: <>Most cabins in Highlands, NC are within 5 to 10 minutes of downtown. {GFC} is just a few minutes&apos; drive from Main Street while still offering a secluded, private setting. Some more remote properties may be 15 to 20 minutes out. It&apos;s worth checking the specific location before booking if proximity to town is important to you.</>,
  },
  {
    q: 'What areas are best to stay in Highlands, NC?',
    a: "Downtown Highlands is ideal for walkable access to restaurants and shops — Old Edwards Inn is the most central option. The Falls Drive corridor is popular for guests who want to be close to waterfalls. Wooded neighborhoods just outside town offer the best balance of privacy and convenience. The Nantahala National Forest area provides the most remote and nature-immersed experience.",
  },
  {
    q: 'What is the best place for a couples getaway in Highlands, NC?',
    a: 'Half-Mile Farm is one of the best options for couples visiting Highlands, NC. It offers a quieter, more intimate setting just outside of downtown, making it a good fit for a relaxed and adults-focused stay.',
  },
  {
    q: 'Are there family friendly vacation rentals in Highlands, NC?',
    a: <>Yes. Many vacation rentals in Highlands, NC are well-suited for families. {GFC} sleeps up to 6 guests and offers a full kitchen, outdoor space, and easy access to waterfall hikes and downtown Highlands. Stag Ridge also accommodates families with its spacious layout and wraparound deck. Both are pet friendly as well.</>,
  },
];

export default function PTSFAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Frequently Asked<br /><em className="italic">Questions</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-lg mx-auto mt-5">
            Answers to the most common questions about places to stay in Highlands, NC.
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-7 py-5 text-left cursor-pointer"
              >
                <span className="font-cormorant text-lg text-[#1A1A18] font-medium leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-base`} />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-7 pb-6">
                  <div className="w-full h-px bg-[#EDE8E0] mb-5" />
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
